import React from "react";
import Hero from "../../components/Hero/index.tsx";
import Navbar from "../../components/Navbar/index.tsx";
import Features from "../../components/Features/index.tsx";
import HowItWorks from "../../components/HowItWorks/index.tsx";
import Pricing from "../../components/Pricing/index.tsx";
import CallToAction from "../../components/CallToAction/index.tsx";
import Footer from "../../components/Footer/index.tsx";

// Tailwind styles applied inline; external CSS removed

const Home = () => {
  return (
    <div className="page">
      <Navbar />
      <Hero />
      <div className="section-divider" />
      <HowItWorks />
      <div className="section-divider" />
      <Features />
      <div className="section-divider" />
      <Pricing />
      <div className="section-divider" />
      <CallToAction />
      <Footer />
    </div>
  );
};

export default Home;
